<template>
  <article class="warpH">
    <section class="data-center">
      <div class="data-center-title">
        <img src="../../stylesheets/images/data-title-small.png" alt="">
      </div>
      <div class="data-center-nav">
        <ul>
          <li v-if="carVisitAuth">
            <router-link to="/manageAnalysis/carVisitDaily">
              <p><i class="data-center-icon car"></i></p>
              <p>车辆进出店统计</p>
            </router-link>
          </li>
          <li v-if="insuranceAuth">
            <router-link :to="`/manageAnalysis/${insuranceUrl}`">
              <p><i class="data-center-icon renewal"></i></p>
              <p>续保统计</p>
            </router-link>
          </li>
          <li v-if="fansAuth">
            <router-link to="/manageAnalysis/fansAnalysis">
              <p><i class="data-center-icon fan-operation"></i></p>
              <p>粉丝运营统计</p>
            </router-link>
          </li>
          <!-- 隐藏销售统计 -->
          <!-- <li v-if="analysisAuth">
            <router-link :to="saleUrl">
              <p><i class="data-center-icon sale-count"></i></p>
              <p>销售统计</p>
            </router-link>
          </li> -->
          <li v-if="clueCarTicketAuth">
            <router-link to="/manageAnalysis/carBusiness">
              <p><i class="data-center-icon car-total"></i></p>
              <p>二手车业务统计</p>
            </router-link>
          </li>
        </ul>
      </div>
    </section>
  </article>
</template>
<script>
import authApi from '../../common/auth'
export default {
  data() {
    return {
      insuranceUrl: 'insurance',
      carVisitAuth: false,
      insuranceAuth: false,
      fansAuth: false,
      clueCarTicketAuth: false,
      saleUrl: ''
    }
  },
  async created() {
    this.switchLoading({ status: true, text: '加载中...' })
    try {
      const { code, data, message } = await this.$rest.dataAnalysis.getCarAuth()
      if (code !== 0) {
        this.switchLoading({ status: false })
        this.showToast(message)
        return
      }

      const storeId = data.store_id
      const hasAuth = data.view_group
      if (!hasAuth) {
        this.insuranceUrl = `insurance/${storeId}`
      }
    } catch (e) {
      this.showToast(e.message)
    }
  },
  mounted () {
    // 权限判断
    this.$store.state.promiseAuth.then(auth => {
      let authList = auth.authList
      this.viewSelf = authList.includes(authApi.busiAnalysis.view_self)
      if (this.viewSelf) {
        this.insuranceAuth = true
        this.carVisitAuth = true
        this.fansAuth = true
        this.clueCarTicketAuth = true
        // this.analysisAuth = true
      } else {
        this.insuranceAuth = authList.includes(authApi.busiAnalysis.insurance_analysis)
        this.carVisitAuth = authList.includes(authApi.busiAnalysis.visit_car)
        this.fansAuth = authList.includes(authApi.busiAnalysis.fans_analysis)
        this.clueCarTicketAuth = authList.includes(authApi.busiAnalysis.busi_analysis_zs_used_car_ticket)
        // this.analysisAuth = this.authList.includes(authApi.busiAnalysis.busi_analysis)
      }
      // 隐藏销售统计入口
      // this.getUrl()
      this.switchLoading({ status: false })
    })
  },
  methods: {
    getUrl () {
      if (this.analysisAuth) {
        this.$rest.dataAnalysis.getCurrentAuth().then(res => {
          if (res.code === 0) {
            if (res.data.have_group_permission) {
              this.saleUrl = '/saleAnalysis/group?type=1'
            } else {
              this.saleUrl = `/saleAnalysis/saleCount?store_id=${res.data.store_id}`
            }
          } else {
            this.showToast(res.message)
          }
        })
      }
    }
  }
}
</script>
<style rel="stylesheet/less" lang="less">
@import "../../stylesheets/modules/data/carData.less";

</style>
